import { Button, Col, Row } from 'antd';
import React, { useState, useEffect } from 'react';
import './assets/fisheryPromotion.css';
import FAQs from './components/FAQ';
import fishery1 from './assets/icon/fishery 1.png';
import fishery2 from './assets/icon/fishery 2.png';
import fishery3 from './assets/icon/fishery 3.png';
import fishery4 from './assets/icon/fishery 4.png';
import fishery5 from './assets/icon/fishery 5.png';
import fishery6 from './assets/icon/fishery 6.png';
import FeatureTable from './components/FeatureTable';
import applePayMark from './assets/icon/apple-Pay.png';
import googlePayMark from './assets/icon/G-Pay.png';
import mastercardMark from './assets/icon/mastercard.png';
import visaMark from './assets/icon/visa.png';
import greenCheck from './assets/icon/greenCheck.svg';
import user from './assets/icon/user-icon.svg';
import web from './assets/icon/web.svg';
import profits from './assets/icon/profits.svg';
import verified from './assets/icon/verified.svg';
import calendar from './assets/icon/calendar.svg';
import callCenter from './assets/icon/call-center.svg';
import agreement from './assets/icon/agreement.svg';
import trustpilot from './assets/icon/trustPilotPng.png';
import { Slider } from '@material-ui/core';
import { styled } from '@mui/styles';
import TextSwitch from '../common/TextSwitch';
import { InfoSlider } from './components/InfoSlider';
import { AdminFeatureSlider } from './components/AdminFeatureSlider';
import { FisheryReviewSlider } from './components/FisheryReviewSlider';
import { Dialog } from '@mui/material';

import { CloseOutlined } from '@ant-design/icons';
import ContactModal from './components/ContactModal';
import YouTube from 'react-youtube';
import { PRIVACY_POLICY_URL } from '../../AppConstants';

const FisheryPromotion = () => {
  const [isMembership, setIsMembership] = React.useState(false);
  const [infoModalVisible, setInfoModalVisible] = useState(false);
  const [contactModalVisible, setContactModalVisible] = useState({
    state: false,
    value: 'contact',
  });

  const fisheryBenefit = [
    'Full access to our Fishery Manager tool',
    'Dedicated bailiff app',
    '1st Line angler support via email & landline',
    'Dedicated fishery account manager',
    'Drone video & photography',
    '360 Degree Virtual Experience',
    'Swim Imagery',
    'Lake Maps (illustrated)',
    'Access to all new development features added to system',
  ];
  const offerBadges = [
    {
      img: fishery1,
      name1: 'Sandhurst',
      name2: 'Lake',
      forceNarrow: true,
    },
    {
      img: fishery2,
      name1: 'Elphicks',
      name2: 'Fisheries',
      forceNarrow: true,
    },
    {
      img: fishery3,
      name1: 'The',
      name2: 'Approach',
    },
    {
      img: fishery4,
      name1: 'Orchid',
      name2: 'Lakes',
      forceNarrow: true,
    },
    {
      img: fishery5,
      name1: 'Doddington',
      name2: 'Lane Pits',
      forceNarrow: true,
    },
    {
      img: fishery6,
      name1: 'Hartley',
      name2: 'Lands',
    },
  ];
  const [colors, setColors] = useState({
    fisheries: 'white',
    clubs: 'sb-blue-200',
    syndicates: 'sb-blue-200',
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setColors((prevColors) => ({
        fisheries: prevColors.syndicates,
        clubs: prevColors.fisheries,
        syndicates: prevColors.clubs,
      }));
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // Wait for the Trustpilot script to load and then initialize the widget
    const loadTrustpilotWidget = () => {
      if (window.Trustpilot) {
        window.Trustpilot.loadFromElement(
          document.getElementsByClassName('trustpilot-widget')[0],
          true
        );
        window.Trustpilot.loadFromElement(
          document.getElementsByClassName('trustpilot-widget')[1],
          true
        );
        window.Trustpilot.loadFromElement(
          document.getElementsByClassName('trustpilot-widget')[2],
          true
        );
      }
    };

    // Check if Trustpilot script is loaded
    if (window.Trustpilot) {
      loadTrustpilotWidget();
    } else {
      // If not loaded, add an event listener to initialize once it loads
      const trustpilotScript = document.createElement('script');
      trustpilotScript.src =
        '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
      trustpilotScript.async = true;
      trustpilotScript.onload = loadTrustpilotWidget;
      document.body.appendChild(trustpilotScript);
    }
  }, []);

  return (
    <div className='grey-bg-100 min-h-screen pd-bottom-10  fishery-claim-box'>
      <Dialog
        open={infoModalVisible}
        PaperProps={{
          style: {
            borderRadius: '20px',
            border: '8px  solid #2772af',
            width: '100%',
          },
        }}
        sx={{ zIndex: 10005 }}
        onOk={() => setInfoModalVisible(false)}
        onClose={() => setInfoModalVisible(false)}
      >
        <div className='infomodal-container'>
          <div
            aria-label='close'
            onClick={() => {
              setInfoModalVisible(false);
            }}
            style={{
              position: 'absolute',
              right: 12,
              top: 12,
            }}
            className='cp'
          >
            <CloseOutlined className='fs-18' />
          </div>
          <h2 className=' sb-blue txt-center gBold'>
            Included When Signing Up
          </h2>
          <div>
            {fisheryBenefit?.map((value) => {
              return (
                <div className=' row-center mg-bottom-10'>
                  <img className='mg-right-15' src={greenCheck} alt='bullets' />
                  <div className='value gMedium'>{value}</div>
                </div>
              );
            })}
          </div>
        </div>
      </Dialog>
      <Dialog
        open={contactModalVisible?.state}
        PaperProps={{
          style: {
            borderRadius: '20px',
            border: '8px  solid #2772af',
            maxWidth: '97%',
            maxHeight: '96%',
            width: '600px',
            background: '#1F5B8C',
          },
        }}
        sx={{ zIndex: 1000 }}
        onOk={() => setContactModalVisible({ state: false, value: 'contact' })}
        onClose={() =>
          setContactModalVisible({ state: false, value: 'contact' })
        }
      >
        <div className='contactmodal-container'>
          <div
            aria-label='close'
            onClick={() => {
              setContactModalVisible({ state: false, value: 'contact' });
            }}
            style={{
              position: 'absolute',
              right: 12,
              top: 12,
            }}
            className='cp'
          >
            <CloseOutlined className='fs-18 white' />
          </div>
          <ContactModal
            setState={setContactModalVisible}
            activeState={contactModalVisible.value}
          />
        </div>
      </Dialog>
      <div className='bg-white mg-bottom-10  fishery-claim-container'>
        <Row
          className='mg-auto justify-between w-full '
          style={{ maxWidth: 1070 }}
        >
          <div className='fs-24 gSemiBold'>
            <span className='sb-blue-600'>Fishery </span>
            Manager
          </div>
          <a href='#offer'>
            <button className=' h-full sb-blue-bg-600 gBold center cp fishery-claim-button'>
              Claim Offer
            </button>
          </a>
        </Row>
      </div>

      <div className='mg-auto' style={{ maxWidth: 1100 }}>
        <Col span={24} lg={0} style={{ marginTop: 105 }}>
          <div className='mg-top-15 px-20' style={{ 'line-height': 'normal' }}>
            <div
              className={`${colors.fisheries} fs-36 gBold`}
              style={{ transition: 'color 1s ease' }}
            >
              Fisheries.
            </div>
            <div
              className={`${colors.clubs} fs-36 gBold`}
              style={{ transition: 'color 1s ease' }}
            >
              Clubs.
            </div>
            <div
              className={`${colors.syndicates} fs-36 gBold`}
              style={{ transition: 'color 1s ease' }}
            >
              Syndicates.
            </div>
            <div className='white fs-36 gBold'>We’ve got you.</div>
          </div>
          <div className='px-20'>
            <div className='h-full w-full mg-top-30 mg-bottom-30'>
              <YouTube
                style={{
                  border: '1px solid #DCE1E5',
                  width: '100%',
                  position: 'relative',
                  borderRadius: '10px',
                }}
                videoId='FObk73Dnm4Y'
                className='h-full main-youtube  mg-auto center cp  br10    '
                opts={{
                  height: '100%',
                  width: '100%',
                }}
              />
            </div>
            <div className='gMedium fs-24 sb-blue-100 mg-bottom-20 '>
              <span className='gSemiBold'>THE </span>
              modern platform for anglers
            </div>
            <Row
              gutter={[10, 10]}
              className='site-info-container mg-bottom-50'
              style={{ lineHeight: 'normal' }}
            >
              <Col className='center box'>
                <div
                  className='br10 bg-white center w-full pd-10 txt-center h-full'
                  style={{ minWidth: '150px', justifyContent: 'flex-end' }}
                >
                  <img src={user} alt='user Logo' className='mg-bottom-10' />
                  <div className='fs-32 gBold sb-blue-600'> 50K+</div>
                  <div className='fs-12 gSemiBold sb-blue-400'>
                    ANGLER ACCOUNTS
                  </div>
                </div>
              </Col>
              <Col className='center box'>
                <div
                  className='br10 bg-white center w-full  pd-10 txt-center h-full'
                  style={{ minWidth: '150px' }}
                >
                  <img src={web} alt='user Logo' className='mg-bottom-10' />
                  <div className='fs-32 gBold sb-blue-600'> 2.5M+</div>
                  <div className='fs-12 gSemiBold sb-blue-400'>WEB VISITS</div>
                </div>
              </Col>
              <Col className='center box'>
                <div
                  className='br10 bg-white center w-full pd-10 txt-center h-full'
                  style={{ minWidth: '150px' }}
                >
                  <img src={profits} alt='user Logo' className='mg-bottom-10' />
                  <div className='fs-32 gBold sb-blue-600'>£7.9M+</div>
                  <div className='fs-12 gSemiBold sb-blue-400'>
                    BOOKINGS PROCESSED
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <div
            className='trustpilot-widget mg-top-20 gRegular'
            data-locale='en-US'
            data-template-id='5419b637fa0340045cd0c936'
            data-businessunit-id='61657394fa7737001e35bc8a'
            data-style-height='40px'
            data-style-width='100%'
            data-theme='dark'
          >
            <a
              href='https://uk.trustpilot.com/review/www.swimbooker.com'
              target='_blank'
              rel='noopener'
            >
              Trustpilot
            </a>
          </div>
          <div className='center mg-bottom-30'>
            <div className='sb-blue-bg-400' style={{ width: 62, height: 2 }}>
              {' '}
            </div>
          </div>
        </Col>
        <Col
          span={0}
          lg={24}
          className=' mg-bottom-50'
          style={{ marginTop: 155 }}
        >
          <Row gutter={[40, 20]} className='px-20 '>
            <Col span={14} className='mg-auto'>
              <div className=' w-full ' style={{ aspectRatio: 16 / 9 }}>
                <YouTube
                  style={{
                    border: '1px solid #DCE1E5',
                    width: '100%',
                    position: 'relative',
                    borderRadius: '10px',
                  }}
                  videoId='FObk73Dnm4Y'
                  className='h-full main-youtube  mg-auto center cp  br10    '
                  opts={{
                    height: '100%',
                    width: '100%',
                  }}
                />
              </div>
              <div
                className='trustpilot-widget mg-top-20 gRegular'
                data-locale='en-US'
                data-template-id='5419b637fa0340045cd0c936'
                data-businessunit-id='61657394fa7737001e35bc8a'
                data-style-height='40px'
                data-style-width='100%'
                data-theme='dark'
              >
                <a
                  href='https://uk.trustpilot.com/review/www.swimbooker.com'
                  target='_blank'
                  rel='noopener'
                >
                  Trustpilot
                </a>
              </div>
            </Col>
            <Col span={10}>
              <div
                className=' mg-bottom-30'
                style={{ 'line-height': 'normal' }}
              >
                <div
                  className={`${colors.fisheries} fs-36 gBold`}
                  style={{ transition: 'color 1s ease' }}
                >
                  Fisheries.
                </div>
                <div
                  className={`${colors.clubs} fs-36 gBold`}
                  style={{ transition: 'color 1s ease' }}
                >
                  Clubs.
                </div>
                <div
                  className={`${colors.syndicates} fs-36 gBold`}
                  style={{ transition: 'color 1s ease' }}
                >
                  Syndicates.
                </div>
                <div className='white fs-36 gBold'>We’ve got you.</div>
              </div>
              <div className='gMedium fs-24 sb-blue-100 mg-bottom-10 '>
                <span className='gSemiBold'>THE </span>
                modern platform for anglers
              </div>
              <Row
                gutter={[10, 10]}
                className='site-info-container'
                wrap={false}
                style={{ lineHeight: 'normal' }}
              >
                <Col span={8}>
                  <div
                    className='br10 bg-white center  pd-10 txt-center h-full'
                    style={{ justifyContent: 'flex-end' }}
                  >
                    <img src={user} alt='user Logo' className='mg-bottom-10' />
                    <div className='fs-32 gBold sb-blue-600'> 50K+</div>
                    <div className='fs-12 gSemiBold sb-blue-400'>ANGLER</div>
                    <div className='fs-12 gSemiBold sb-blue-400'>ACCOUNTS</div>
                  </div>
                </Col>
                <Col span={8}>
                  <div className='br10 bg-white center  pd-10 txt-center h-full'>
                    <img src={web} alt='web Logo' className='mg-bottom-10' />
                    <div className='fs-32 gBold sb-blue-600'> 2.5M+</div>
                    <div className='fs-12 gSemiBold sb-blue-400'>WEB</div>
                    <div className='fs-12 gSemiBold sb-blue-400'>VISITS</div>
                  </div>
                </Col>
                <Col span={8}>
                  <div className='br10 bg-white center  pd-10 txt-center h-full'>
                    <img
                      src={profits}
                      alt='profit Logo'
                      className='mg-bottom-10'
                    />
                    <div className='fs-32 gBold sb-blue-600'>£7.9M+</div>
                    <div className='fs-12 gSemiBold sb-blue-400'>
                      BOOKINGS PROCESSED
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <div className='px-20 '>
          <Col span={24} lg={0}>
            <div className='fs-32 gBold white '>Why swimbooker?</div>
            <p className='fs-16 gSemiBold sb-blue-100 mg-bottom-25'>
              We are quickly becoming THE preferred booking platform for anglers
              and fisheries alike.
            </p>
          </Col>
          <Col span={0} lg={24}>
            <div className='fs-40 gBold white '>Why swimbooker?</div>
            <p className='fs-22 gSemiBold sb-blue-100 mg-bottom-25'>
              We are quickly becoming THE preferred booking platform for anglers
              and fisheries alike.
            </p>
          </Col>
        </div>
        <InfoSlider />
        <div className='px-20 mg-bottom-15'>
          <Col span={24} lg={0}>
            <div className='fs-32 gBold grey-900 '>A world of difference</div>
            <p className='fs-16 gSemiBold grey-800 mg-bottom-30'>
              Lakes on our platform experience real change in terms of time
              saved, bookings received and membership increase!
            </p>
          </Col>
          <Col span={0} lg={24}>
            <div className='fs-40 gBold grey-900 txt-center mg-bottom-20'>
              A world of difference...
            </div>
            <p className='fs-24 gSemiBold txt-center grey-800 mg-bottom-40'>
              Lakes on our platform experience real change in terms of
              efficiency, bookings received and time spent doing admin!
            </p>
          </Col>
          <Row gutter={[20, 20]} className='justify-around'>
            <Col span={24} style={{ alignContent: 'center' }}>
              <Row>
                <Col className='w-full'>
                  <TextSwitch
                    className='member-switch mg-auto gSemiBold mg-bottom-20'
                    checkedColourClass='sb-blue-bg-600'
                    uncheckedColourClass='sb-blue-bg-600'
                    checked={isMembership}
                    onChange={(v) => {
                      setIsMembership(v);
                    }}
                    checkedChildren='Syndicates & 
          Memberships'
                    unCheckedChildren='Ticket Lakes &
          Lake Exclusives'
                  />
                </Col>
              </Row>
            </Col>
            <Col span={24} lg={19}>
              {isMembership ? (
                <div>
                  <Row
                    gutter={[{ xs: 10, sm: 16, md: 24, lg: 50 }, 10]}
                    className='justify-center mg-bottom-30'
                    // style={{ lineHeight: 'normal' }}
                  >
                    <Col span={24} md={{ span: 12, order: 1 }} order={2}>
                      <Row
                        gutter={[{ xs: 10, sm: 16, md: 24, lg: 50 }, 10]}
                        className='justify-center'
                        // style={{ lineHeight: 'normal' }}
                      >
                        <Col span={12}>
                          <div className='br20 bg-white h-full center justify-center pd-15'>
                            <div className='fs-40 gBold sb-blue-400'> 50</div>
                            <div className='fs-13 gBold grey-700 txt-center'>
                              HOURS
                            </div>
                            <div className='fs-13 gBold grey-700 txt-center'>
                              SAVED
                            </div>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div className='br20 bg-white h-full center justify-center pd-15'>
                            <div className='fs-40 gBold sb-blue-400'>
                              1.25<span className='fs-30'>x</span>
                            </div>
                            <div className='fs-13 gBold grey-700 txt-center'>
                              INCREASED
                            </div>
                            <div className='fs-13 gBold grey-700 txt-center'>
                              RENEWAL RATE
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={24} md={{ span: 12, order: 1 }} order={1}>
                      <div className='w-fit mg-auto h-full display-flex-column justify-center   pd-15'>
                        <div className=' row-center   mg-bottom-10'>
                          <img
                            className='mg-right-15'
                            src={greenCheck}
                            alt='bullets'
                            width={24}
                          />
                          <div className='value grey-700 fs-13 gBold'>
                            FULLY MANAGED WAITING LIST
                          </div>
                        </div>
                        <div className=' row-center  mg-bottom-10'>
                          <img
                            className='mg-right-15'
                            src={greenCheck}
                            alt='bullets'
                            width={24}
                          />
                          <div className='value grey-700 fs-13 gBold'>
                            AUTOMATED RENEWAL SYSTEM & REMINDERS
                          </div>
                        </div>
                        <div className=' row-center mg-bottom-10'>
                          <img
                            className='mg-right-15'
                            src={greenCheck}
                            alt='bullets'
                            width={24}
                          />
                          <div className='value grey-700 fs-13 gBold'>
                            DETAILED MEMBER DIGITAL RECORDS
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <div className='fs-15 gMedium grey-700 txt-center mg-bottom-50'>
                    *Annual average based on 100 members
                  </div>
                </div>
              ) : (
                <div>
                  <Row
                    gutter={[{ xs: 10, sm: 16, md: 24, lg: 50 }, 10]}
                    className='justify-center mg-bottom-30'
                    // style={{ lineHeight: 'normal' }}
                  >
                    <Col span={12} md={6}>
                      <div className='br20 bg-white h-full center justify-center pd-10'>
                        <div className='fs-40 gBold sb-blue-400'> 22</div>
                        <div className='fs-13 gBold grey-700 txt-center'>
                          ADMIN HOURS
                        </div>
                        <div className='fs-13 gBold grey-700 txt-center'>
                          SAVED
                        </div>
                      </div>
                    </Col>
                    <Col span={12} md={6}>
                      <div className='br20 bg-white h-full center justify-center pd-10'>
                        <div className='fs-40 gBold sb-blue-400'>44%</div>
                        <div className='fs-13 gBold grey-700 txt-center'>
                          INCREASED
                        </div>
                        <div className='fs-13 gBold grey-700 txt-center'>
                          REVENUE
                        </div>
                      </div>
                    </Col>
                    <Col span={12} md={6}>
                      <div className='br20 bg-white h-full center justify-center pd-10'>
                        <div className='fs-40 gBold sb-blue-400'>60%</div>
                        <div className='fs-13 gBold grey-700 txt-center'>
                          REDUCTION IN
                        </div>
                        <div className='fs-13 gBold grey-700 txt-center'>
                          PHONE CALLS
                        </div>
                      </div>
                    </Col>
                    <Col span={12} md={6}>
                      <div className='br20 bg-white h-full center justify-center pd-10'>
                        <div className='fs-40 gBold sb-blue-400'>
                          1.5<span className='fs-30'>x</span>
                        </div>
                        <div className='fs-13 gBold grey-700 txt-center'>
                          CATCH REPORTS SUBMITTED
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <div className='fs-15 gMedium grey-700 txt-center mg-bottom-50'>
                    *Weekly averages based on data gathered from over 50 venues
                    using swimbooker for over 12 months
                  </div>
                </div>
              )}
            </Col>
          </Row>
        </div>
        <AdminFeatureSlider />
        <div className='px-20'>
          <Col span={24} lg={0}>
            <div
              className='fs-32 gBold grey-900 mg-bottom-15'
              style={{ lineHeight: 'normal' }}
            >
              Powerful management tools.
            </div>
            <p className='fs-16 gSemiBold grey-800 mg-bottom-25'>
              We’re constantly adding even more features to our best-in-class
              software solution.
            </p>
          </Col>
          <Col span={0} lg={24} className='txt-center'>
            <div
              className='fs-40 gBold grey-900 mg-bottom-15'
              style={{ lineHeight: 'normal' }}
            >
              Powerful management tools.
            </div>
            <p className='fs-22 gSemiBold grey-800 mg-bottom-50 '>
              We’re constantly adding even more features to our best-in-class
              software solution.
            </p>
          </Col>
          <FeatureTable />
        </div>
        <div className='px-20  '>
          <Col span={24} lg={0}>
            <div className='fs-32 gBold grey-900 '>Easy as 1,2,3...4</div>
            <p className='fs-16 gSemiBold grey-800 mg-bottom-25'>
              On average, lakes are live on our platform within 7 days of
              joining.
              <span className='gBold'> Less Hassle. More Bookings.</span>
            </p>
          </Col>
          <Col span={0} lg={24}>
            <div className='fs-40 txt-center gBold grey-900 mg-bottom-20 '>
              Easy as 1,2,3...4
            </div>
            <p className='fs-22 txt-center gSemiBold grey-800 mg-bottom-50'>
              On average, lakes are live on our platform within 7 days of
              joining.
              <span className='gBold'> Less Hassle. More Bookings.</span>
            </p>
          </Col>
          <Row gutter={[20, 20]} style={{ lineHeight: 'normal' }}>
            <Col span={12} lg={6}>
              <div
                className='br30 bg-white  justify-between pd-20 h-full'
                style={{ flexDirection: 'column' }}
              >
                <div
                  className='fs-32 gBold sb-blue-600 center '
                  style={{ display: 'flex', alignItems: 'start' }}
                >
                  {' '}
                  <div>1</div>
                  <div
                    className='center mg-auto mg-bottom-15 easy-step-img-container'
                    style={{ height: '125px' }}
                  >
                    <img src={agreement} alt='agreement' className='mg-auto' />
                  </div>
                </div>
                <div className='fs-16 gSemiBold txt-center '>
                  Easy Signup. No Minimum Length.
                </div>
              </div>
            </Col>
            <Col className='onboarding' span={12} lg={6}>
              <div
                className='br30 bg-white  justify-between pd-20 h-full'
                style={{ flexDirection: 'column' }}
              >
                <div
                  className='fs-32 gBold sb-blue-600 center '
                  style={{ display: 'flex', alignItems: 'start' }}
                >
                  {' '}
                  <div>2</div>
                  <div
                    className='center mg-auto mg-bottom-15 easy-step-img-container'
                    style={{ height: '125px' }}
                  >
                    <img src={callCenter} alt='call' className='mg-auto' />
                  </div>
                </div>

                <div className='fs-16 gSemiBold txt-center '>
                  Onboarding Call 15-20 minutes
                </div>
              </div>
            </Col>
            <Col span={12} lg={6}>
              <div
                className='br30 bg-white  justify-between pd-20 h-full '
                style={{ flexDirection: 'column' }}
              >
                <div
                  className='fs-32 gBold sb-blue-600 center '
                  style={{ display: 'flex', alignItems: 'start' }}
                >
                  {' '}
                  <div>3</div>
                  <div
                    className='center mg-auto mg-bottom-15 easy-step-img-container'
                    style={{ height: '125px' }}
                  >
                    <img src={verified} alt='verified' className='mg-auto' />
                  </div>
                </div>

                <div className='fs-16 gSemiBold txt-center '>
                  Profile Creation. Bookings Transferred.
                </div>
              </div>
            </Col>
            <Col span={12} lg={6}>
              <div
                className='br30 bg-white  justify-between pd-20 h-full'
                style={{ flexDirection: 'column' }}
              >
                <div
                  className='fs-32 gBold sb-blue-600 center '
                  style={{ display: 'flex', alignItems: 'start' }}
                >
                  {' '}
                  <div>4</div>
                  <div
                    className='center mg-auto mg-bottom-15 easy-step-img-container'
                    style={{ height: '125px' }}
                  >
                    <img src={calendar} alt='calendar' className='mg-auto' />
                  </div>
                </div>
                <div className='fs-20 gBold txt-center '>GO LIVE!</div>
              </div>
            </Col>
          </Row>
        </div>
        <div id='offer'></div>
        <div className=' offer-container  '>
          <Col span={24} lg={0}>
            <div className='fs-32 gBold grey-900 white'>
              Simple, transparent pricing
            </div>
            <p className='fs-16 gSemiBold sb-blue-100 mg-bottom-20'>
              In addition to being zero cost to anglers, our pricing reflects
              fair value to lake owners.
            </p>
            <p
              className='fs-18 gSemiBold sb-blue-200 cp txt-underline  mg-bottom-20'
              onClick={() => setInfoModalVisible(true)}
            >
              What’s Included?
            </p>
          </Col>
          <Col span={0} lg={24}>
            <div className='fs-40 gBold grey-900 txt-center mg-bottom-30 white'>
              Simple, transparent pricing
            </div>
            <p className='fs-22 gSemiBold mg-bottom-40 sb-blue-100 txt-center'>
              In addition to being zero cost to anglers, our pricing reflects
              fair value to lake owners.
            </p>
            <p
              className='fs-22 gSemiBold cp sb-blue-200 txt-underline txt-center  mg-bottom-50'
              onClick={() => setInfoModalVisible(true)}
            >
              What’s Included?
            </p>
          </Col>
          <Row
            gutter={[10, 20]}
            className='mg-bottom-30'
            style={{ lineHeight: 'normal' }}
          >
            <Col span={24} lg={8}>
              <div className='br30 center bg-white h-full   justify-between pd-20'>
                <div className=' gBold seagreen-600' style={{ fontSize: 48 }}>
                  {' '}
                  <span className='fs-20'>£</span>0
                </div>
                <div className='fs-16 gBold txt-center grey-700 '>
                  SETUP & ANGLER FEES
                </div>
              </div>
            </Col>
            <Col span={24} lg={8}>
              <div className='center br30 bg-white h-full   justify-between pd-20'>
                <div className='special-tag'> Special offer</div>
                <div
                  className='row-center gap-1r justify-center'
                  style={{ width: '194px' }}
                >
                  <div
                    className=' gBold seagreen-600'
                    style={{ fontSize: 48, position: 'relative' }}
                  >
                    {' '}
                    <span className='fs-20'>£</span>20
                    <div className='diagonal-line'></div>
                  </div>
                  <div className=' gBold seagreen-600 fs-20'>
                    FREE FOR 12 MONTHS{' '}
                  </div>
                </div>
                <div className='fs-13 gBold txt-center grey-700'>
                  MONTHLY SUBSCRIPTION
                </div>
              </div>
            </Col>
            <Col span={24} lg={8}>
              <div className='center br30  bg-white  justify-between pd-20 h-full'>
                <div className=' gBold seagreen-600 fs-36'>1.5% + 0.30P</div>
                <div className='fs-13 gBold txt-center grey-700'>
                  ONLINE BOOKING FEE*
                </div>
              </div>
            </Col>
          </Row>
          <p
            className='fs-13 gMedium txt-center mg-bottom-25'
            style={{ color: '#8ABCE5', position: 'relative', zIndex: 1 }}
          >
            *Fees are only charged on online bookings made by anglers. Bookings
            added to calendar by admins are not charged.
          </p>
          <div
            className='w-full mg-bottom-30 mg-auto'
            style={{ maxWidth: 450, position: 'relative', zIndex: 1 }}
          >
            <div className='row-center px-20 justify-center flex-wrap'>
              <img src={applePayMark} alt='Apple Pay Logo' width={75} />
              <img src={googlePayMark} alt='Google Pay Logo' width={75} />
              <img src={mastercardMark} alt='Mastercard Logo' width={75} />
              <img src={visaMark} alt='Visa Logo' width={75} />
            </div>
          </div>
          <Row className='w-full'>
            <Col span={24}>
              <div className='center mg-bottom-20'>
                <div
                  className='in-touch_button white gBold fs-18 w-full pd-10 center cp'
                  onClick={() =>
                    setContactModalVisible({ state: true, value: 'contact' })
                  }
                >
                  Get In Touch
                </div>
              </div>
              <div className='center mg-bottom-20'>
                <div
                  className='txt-underline white gBold fs-18 w-full  center cp'
                  onClick={() =>
                    setContactModalVisible({ state: true, value: 'demo' })
                  }
                >
                  Request Product Demo
                </div>
              </div>
            </Col>
            <Col span={24} className='px-20 mg-bottom-40'>
              <p className='txt-center gBold fs-20 mg-bottom-30 white'>
                Powering the largest lakes in the UK & abroad
              </p>
              <Row gutter={[30, 30]} className='offer-badge justify-between'>
                {offerBadges.map(
                  ({ img, name1, name2, forceNarrow = false }) => (
                    <Col
                      span={8}
                      sm={4}
                      lg={3}
                      key={name1}
                      className='center container justify-center'
                    >
                      <img
                        src={img}
                        alt={name1}
                        className='w-full mg-bottom-10'
                      />
                      <div className=' gSemiBold sb-blue-100'>{name1}</div>
                      <div className=' gSemiBold sb-blue-100'>{name2}</div>
                    </Col>
                  )
                )}
              </Row>
            </Col>
          </Row>
        </div>
        <Col span={24} md={0} className='pd-top-10'>
          <div className='center'>
            <div className='gSemiBold fs-28  grey-900'>
              Don’t take it from us...
            </div>
            <div className='gRegular fs-16  grey-900'>Swipe for more</div>
          </div>
        </Col>
        <Col span={0} md={24}>
          <div className='center'>
            <div className='gSemiBold fs-40  grey-900'>
              Don’t take it from us...
            </div>
          </div>
        </Col>

        <FisheryReviewSlider />
        <div className='mg-top-20   main_container_padding'>
          <div
            className='trustpilot-widget gRegular main_container_padding__content'
            data-locale='en-US'
            data-template-id='53aa8912dec7e10d38f59f36'
            data-businessunit-id='61657394fa7737001e35bc8a'
            data-style-height='140px'
            data-style-width='100%'
            data-stars='4,5'
            data-review-languages='en'
          >
            <a
              href='https://uk.trustpilot.com/review/www.swimbooker.com'
              target='_blank'
              rel='noopener'
            >
              Trustpilot
            </a>
          </div>
        </div>
        <div className='px-20 center' style={{ marginTop: '60px' }}>
          <Col span={24} lg={0}>
            <div className='gSemiBold grey-900 fs-28 mg-bottom-10 txt-center'>
              Questions?
            </div>
            <div
              className='gMedium fs-16 mg-bottom-20'
              style={{ color: '#062620' }}
            >
              We’ve got answers.
            </div>
          </Col>
          <Col span={0} lg={24}>
            <div className='gSemiBold grey-900 fs-40 mg-bottom-10 txt-center'>
              Questions?
            </div>
            <div
              className='gMedium fs-24 mg-bottom-20'
              style={{ color: '#062620' }}
            >
              We’ve got answers.
            </div>
          </Col>
          <FAQs />
        </div>
        <div>
          <div className='grey-400 mg-top-30 fs-12 gMedium txt-center mg-bottom-15'>
            Copyright © SWIMBOOKER LIMITED 2024
          </div>
          <div className='center'>
            <a
              href='https://swimbooker.com'
              className='grey-400 fs-12 w-full gMedium txt-center txt-underline mg-bottom-15'
            >
              Home
            </a>
          </div>
          <div className='center'>
            <a
              href={PRIVACY_POLICY_URL}
              className='grey-400 fs-12 w-full gMedium txt-center txt-underline mg-bottom-15'
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FisheryPromotion;
